export default "__VITE_ASSET__CGkI96SQ__"